<section class="flex items-center">
    <article class="rounded w-full h-10">
      <app-input-search [placeholder]="placeholder" [width]="'full'" (submitEventEmitter)="search($event)"></app-input-search>
    </article>
    @if (searching) {
      <img [src]="images.loading" alt="loading" class="h-10 w-10" />
    }
  </section>
  